var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthDiaryViewMedicineEntries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff4a4a;}.cls-2{fill:#fce3f1;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_130",
    "data-name": "Layer 130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.11,425.25,303.65,547.71C232.34,619,116.7,618,48.55,543.65A175.5,175.5,0,0,1,53.89,301l124-124a.18.18,0,0,1,.25,0l248,248A.19.19,0,0,1,426.11,425.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177.57,177,300,54.5c71.3-71.3,186.94-70.26,255.1,4.06a175.49,175.49,0,0,1-5.35,242.65l-124,124a.18.18,0,0,1-.25,0l-248-248A.18.18,0,0,1,177.57,177Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M425.09,41.91a135.28,135.28,0,0,1,95.17,231L396.53,396.66l-28.29,28.28.18.18-94.31,94.31a137.85,137.85,0,0,1-98,40.88,135.28,135.28,0,0,1-95.16-231L204.62,205.5l28.26-28.29-.11-.11,94.31-94.31a137.85,137.85,0,0,1,98-40.88m0-40A178.24,178.24,0,0,0,298.79,54.5L176.33,177a.18.18,0,0,0,0,.25L52.64,301A175.2,175.2,0,0,0,176.1,600.31a178.27,178.27,0,0,0,126.3-52.6L424.86,425.25a.19.19,0,0,0,0-.26l-.05-.05L548.54,301.21A175.19,175.19,0,0,0,425.09,1.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 125.8,
    cy: 388.99,
    rx: 61.02,
    ry: 36.23,
    transform: "translate(-247.15 221.53) rotate(-47.9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthDiaryViewMedicineEntries);
export default __webpack_public_path__ + "static/media/health_diary_view_medicine_entries.f7ba458566e0ea2932506c6441663229.svg";
export { ForwardRef as ReactComponent };